
$(document).ready(function() { 
  
$(".product-single__quantity-label").on( "click", function() { 

  var isSomethingToCart = 0;
    var somethingToCart = {items: []};
    if( $("#doplataZmianaKola").val() == "true") {
      var newItem = {
        'id': 48517307892047,
        'quantity': 1,
        'properties': {'_coverProjectID': $("#tokenInput").val() }
      }; 
      somethingToCart.items.push(newItem);      
      isSomethingToCart = 1;
    } 
    if( $("#kosztMatryca1").length ) {
      var newItem = {
        'id': 48517307793743,
        'quantity': $("#kosztMatryca1").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      }; 
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    } 
    if( $("#kosztMatryca2").length ) {
      var newItem = {
        'id': 48517307826511,
        'quantity': $("#kosztMatryca2").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };   
      somethingToCart.items.push(newItem);  
      isSomethingToCart = 1;             
    }   
    if( $("#kosztMatryca5").length ) {
      var newItem = {
        'id': 48517307859279,
        'quantity': $("#kosztMatryca5").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    } 
    if( $("#doplataMatryca2").length ) {
      var newItem = {
        'id': 48517307924815,
        'quantity': $("#doplataMatryca2").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };   
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    }   
    if( $("#doplataMatryca5").length ) {
      var newItem = {
        'id': 48517307957583,
        'quantity': $("#doplataMatryca5").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };
      somethingToCart.items.push(newItem); 
      isSomethingToCart = 1;              
    } 

      console.log( somethingToCart);
});  


$(".product-form__cart-submit").on( "click", function() { 
setTimeout(
  function() 
  {
    //do something special
  }, 2000);

  
    var isSomethingToCart = 0;
    var somethingToCart = {items: []};
    if( $("#doplataZmianaKola").val() == "true") {
      var newItem = {
        'id': 48517307892047,
        'quantity': 1,
        'properties': {'_coverProjectID': $("#tokenInput").val() }
      }; 
      somethingToCart.items.push(newItem);      
      isSomethingToCart = 1;
    } 
    if( $("#kosztMatryca1").length ) {
      var newItem = {
        'id': 48517307793743,
        'quantity': $("#kosztMatryca1").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      }; 
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    } 
    if( $("#kosztMatryca2").length ) {
      var newItem = {
        'id': 48517307826511,
        'quantity': $("#kosztMatryca2").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };   
      somethingToCart.items.push(newItem);  
      isSomethingToCart = 1;             
    }   
    if( $("#kosztMatryca5").length ) {
      var newItem = {
        'id': 48517307859279,
        'quantity': $("#kosztMatryca5").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    } 
    if( $("#doplataMatryca2").length ) {
      var newItem = {
        'id': 48517307924815,
        'quantity': $("#doplataMatryca2").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };   
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    }   
    if( $("#doplataMatryca5").length ) {
      var newItem = {
        'id': 48517307957583,
        'quantity': $("#doplataMatryca5").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };
      somethingToCart.items.push(newItem); 
      isSomethingToCart = 1;              
    } 


    if( isSomethingToCart > 0 ) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js', // Shopify's cart endpoint
        data: somethingToCart,
        dataType: 'json',
        async: false,              
        success: function(response) {
            //window.location = '/cart';                  
            console.log('Product added to the cart:', response);
            // You can perform actions after adding the product to the cart here
        }
      });     
    }

});




});